<template>
    <ModalComponent
        name="addMonedero"
        :title="'Nueva transacion para ' + abonado.name + ' ' + abonado.surnames"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" class="row" @submit.prevent="submit">
            <div class="col-12">
                <FormInput label="Descripcion" type="text" name="descripcion" id="descripcion" rules="required" v-model="data.descripcion" />
            </div>
            <div class="col-12">
                <FormInput label="Importe (Decimales con punto)" type="number" step="any" name="importe" id="importe" rules="required" v-model="data.importe" />
            </div>
            <div class="col-12" v-if="error">
                <div class="alert alert-danger" role="alert">
                    {{ error }}
                </div>
            </div>
            <div class="col-12 mt-3">
                <Button type="submit" :disabled="loading">añadir</Button>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>


<script>
import ModalComponent from "@/components/backend/components/ModalComponent";
export default {
    props: ['abonado'],
    data() {
        return {
            data: {
                descripcion: '',
                importe: '',
            },
            loading: false,
            error: null,  
        }
    },
    methods: {
        close(data) {
            this.data = {
                descripcion: '',
                importe: '',
            }; 
            this.$emit('close', 'addMonedero', data);
        },

        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.data.abonado_id = this.abonado.id;
                this.loading = true;
                this.$store.dispatch(this.config.getVuexAlias('back.abonados.monedero.add'), this.data).then(res => {
                    this.close(false);
                    this.loading = false;
                }).catch( er => {
                    this.error = er.response.data.message;
                    this.loading = false;
                });
            }
        },
    },
    components: {
        ModalComponent
    }
}
</script>